<template>
  <div class="container">
    <h2>First, let's verify your work email</h2>
    <template v-if="!sentEmail">
      <p>
        To verify your employment with
        {{
          getApplicantVerification
            ? getApplicantVerification.request_data
                .applicant_employer_organization_name
            : ""
        }}, follow these simple steps:
      </p>
      <p>1. Enter your WORK EMAIL ADDRESS in the box below.</p>
      <p>2. Click the “Send Email” button.</p>
      <p>
        3. Go to your WORK EMAIL, open the message we just sent, and click the
        “Verify” button
      </p>
      <div class="input">
        <input
          v-model="email"
          type="email"
          placeholder="Example: jane_smith@acme.com"
        />
      </div>
      <div class="actions" style="display:flex; flex-direction:column;">
        <a class="send" @click="sendVerificationEmail"
          >Send Email <img src="@/assets/arrow.svg"
        /></a>
        <a class="skip" @click="openSkipModal()">Skip</a>
      </div>
    </template>
    <template v-else>
      <p class="email_sent">
        Email sent. Please check your mailbox to verify your email address.
      </p>
    </template>
    <skip-modal skip-type="email" @skip="skipEmailVerification" />
  </div>
</template>
<script>
import {
  APPLICANT_VERIFICATION_ADD_EMAIL_VERIFICATION,
  APPLICANT_VERIFICATION_VERIFY_EMAIL
} from "@/store/types";

import { mapGetters } from "vuex";
import SkipModal from "../../components/SkipModal.vue";

export default {
  components: { SkipModal },
  data() {
    return {
      email: "",
      sentEmail: false
    };
  },
  computed: {
    ...mapGetters(["isApplicantLoading", "getApplicantVerification"])
  },
  async mounted() {
    const token = this.$route.params.emailVerifyToken;

    if (token) {
      //token has already set on headers on VerificationApplicant.vue

      try {
        await this.$store.dispatch(APPLICANT_VERIFICATION_VERIFY_EMAIL, token);
        this.$router.push({ name: "verify-applicant-income" });
      } catch (err) {
        console.log(err);
      }
    }
  },
  methods: {
    openSkipModal() {
      this.$modal.show("skip");
    },
    async sendVerificationEmail() {
      try {
        await this.$store.dispatch(
          APPLICANT_VERIFICATION_ADD_EMAIL_VERIFICATION,
          {
            email: this.email
          }
        );

        this.sentEmail = true;
      } catch (err) {
        this.sentEmail = true;
        console.log(err);
      }
    },
    async skipEmailVerification() {
      try {
        await this.$store.dispatch(
          APPLICANT_VERIFICATION_ADD_EMAIL_VERIFICATION,
          {
            email_skipped: true
          }
        );
        this.$router.push({ name: "verify-applicant-income" });
      } catch (err) {
        console.log(err);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  max-width: 700px;
  height: 100vh;
  margin: auto;
  padding: 30px 0px;
  h2 {
    font-size: 45px;
    line-height: 64px;
    font-weight: 400;
  }
  p {
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 34px;
    color: #545454;
  }
  .input {
    display: flex;
    justify-content: center;
    margin-top: 50px;
    input {
      max-width: 500px;
      width: 100%;
      margin-top: 5px;
      border-radius: 2px;
      border: 2px solid #cfcfd2;
      font-size: 16px;
      background: #f6f6f6;
      color: #545454;
      padding: 15px;
      line-height: 1;
    }
  }
}
h2 {
  text-align: center;
}

.email_sent {
  margin-top: 50px;
  text-align: center;
}
.actions {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 50px;

  .send {
    display: block;
    width: 150px;
    padding: 10px 0;
    border: 2px solid #3ec19d;
    background: #3ec19d;
    border-radius: 2px;
    text-decoration: none;
    font-size: 18px;
    color: #fff;
    text-align: center;
    font-weight: 600;
    cursor: pointer;
    font-size: 18px;
    margin: 10px;
    font-weight: 400;

    img {
      position: relative;
      top: 2.5px;
      margin-left: 7px;
    }
  }
  .skip {
    text-decoration: underline;
    cursor: pointer;
  }
}
@media (max-width: 768px) {
  .container {
    padding: 30px 15px;
    h2 {
      margin-top: 0px;
      font-size: 32px;
      line-height: 45px;
      font-weight: 400;
    }
    p {
      font-size: 16px;
      line-height: 25px;
    }
  }
}
</style>
